import { styled } from '@mui/material/styles';
import { Button, Divider, Paper, Skeleton, Typography } from '@mui/material';
import { Link, createSearchParams, useParams } from 'react-router-dom';

export const UBItem = ({ styles, title, titleButton = true, centered, centeredTitle, titleStatus, children, childrenStatus, id }) => {
    const { dashboard: pDashboard } = useParams();

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: 'transparent',
        color: 'white',
        boxSizing: 'border-box',
        height: "100%",
        padding: 5,
        ...styles
    }));

    return (
        <Item>
            {title &&
                titleButton ?
                    <>
                        <Button
                            component={Link}
                            to={{ pathname: `/unionbank/${pDashboard}/hourly`, search: `?${createSearchParams({categoryName: id})}`}}
                            sx={{ color: 'white', display: 'block', textTransform: 'none' }}
                        >
                        {titleStatus === "loading" ? <Skeleton /> : <Typography onClick={() => { }} variant="h5" fontWeight="bold" align={(centered && centeredTitle) || centeredTitle ? "center" : "left"}>{title}</Typography>}
                        </Button>

                        <Divider />
                    </>
                :
                    <>
                        {titleStatus === "loading" ? <Skeleton /> : <Typography onClick={() => { }} variant="h5" fontWeight="bold" align={(centered && centeredTitle) || centeredTitle ? "center" : "left"}>{title}</Typography>}
                    </>
            }

            {childrenStatus === "loading" ? <><Skeleton/><Skeleton/><Skeleton/></> : children}
        </Item>
    );
}